import React from 'react';
import { HistoricalPosition } from '../../services/adminService';
import PositionItem from './PositionItem';

interface PositionListProps {
  loading: boolean;
  records: HistoricalPosition[];
  onRefresh: () => void;
}

const PositionList: React.FC<PositionListProps> = ({ loading, records, onRefresh }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
      </div>
    );
  }

  if (records.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-gray-400 mb-2">暂无历史持仓记录</div>
        <button
          onClick={onRefresh}
          className="mt-4 px-4 py-2 bg-white/10 border border-white/20 rounded-lg text-white text-sm hover:bg-white/20 transition-colors"
        >
          刷新
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {records.map((record) => (
        <PositionItem key={record.id} record={record} />
      ))}
    </div>
  );
};

export default PositionList;
